var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftwareLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "go to index"), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 16,
    r: 14,
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    stroke: "#000",
    transform: "matrix(1,0,0,0.9201367328137158,0,11.498902880486149) ",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 16,
    id: "svg_0",
    y: 11,
    x: 4,
    strokeWidth: 0,
    fill: "#fff"
  }, "KS"), /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    stroke: "#000",
    transform: "matrix(1,0,0,0.9201367328137158,0,11.498902880486149) ",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 24,
    id: "svg_1",
    y: 13.781243,
    x: 35,
    strokeWidth: 0,
    fill: "rgba(0, 0, 0, 0.85)"
  }, "task manage"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareLogo);
export default __webpack_public_path__ + "static/media/software-logo.a0943b211610b2db3d9ca4a5dcad7ec0.svg";
export { ForwardRef as ReactComponent };